<div class="overlay">
  <table class="wrapper">
    <tr>
      <td>
        <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
        <div class="pop-up-container">
          <img
            class="popup-img"
            src="./assets/images/{{ data.currentLanguage }}/{{
              data.currentLanguage
            }}_rtp_info.webp"
          />
          <div
            class="table-popup-text lang-specific-font-name"
            [ngStyle]="{
              'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
            }"
          >
            {{ 'LANG00177' | translate }}
          </div>
          <div class="table-live-txt" [ngClass]="[isMac + 'table-live-txt']">
            <img
              [ngClass]="['table-icon-' + data.info.featureName]"
              src="./assets/images/lobby_sprite_images/common/menu_sprite_images/{{
                data.info.featureName
              }}_icon.webp"
            />
            <span
              class="table-txt lang-specific-font-name"
              [ngStyle]="{
                'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
              }"
              >{{ data.info.langCode | translate }}</span
            >
          </div>

          <img
            class="close-icon-img"
            src="./assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp"
            (click)="onCloseClick($event)"
          />
          <img
            class="infor info_icon"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/info_icon.webp"
            (click)="onInfoClick(0)"
          />

          <img
            class="infor info_icon1"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/info_icon.webp"
            (click)="onInfoClick(7)"
          />

          <img
            class="infor info_icon2"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/info_icon.webp"
            (click)="onInfoClick(16)"
          />

          <img
            class="infor info_icon3"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/info_icon.webp"
            (click)="onInfoClick(18)"
          />

          <img
            class="icons bet_icon"
            [ngClass]="[isMac + 'icons']"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/bet_icon.webp"
          />
          <span
            class="lang-specific-header-text bet_text lang-specific-font-name"
            [ngClass]="[isMac + 'header-text']"
            >{{ data.currencySymbol
            }}{{ data.info.minbet | usercurrency | currencysymbol }}-{{
              data.currencySymbol
            }}{{ data.info.maxbet | usercurrency | currencysymbol }}</span
          >
          <img
            class="down_arrow2"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/down_arrow2.webp"
          />

          <img
            class="icons decks_icon"
            [ngClass]="[isMac + 'decks_icon']"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/decks_icon.webp"
          />
          <span
            class="lang-specific-header-text lang-specific-decks_text lang-specific-font-name"
            [ngStyle]="{
              'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
            }"
            [ngClass]="[
              isMac + 'header-text',
              isMac + 'lang-specific-decks_text'
            ]"
            >{{ data.info.decks }} {{ 'LANG00153' | translate }}</span
          >

          <img
            class="icons shuffle_icon"
            [ngClass]="[isMac + 'shuffle_icon']"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/shuffle_icon.webp"
          />
          <span
            class="lang-specific-header-text lang-specific-shuffle_text lang-specific-font-name"
            [ngStyle]="{
              'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
            }"
            [ngClass]="[isMac + 'header-text']"
            >{{ 'LANG00158' | translate }}{{ ' '
            }}{{ data.info.shuffles }}</span
          >

          <img
            class="icons split_icon"
            [ngClass]="[isMac + 'split_icon']"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/split_icon.webp"
          />
          <span
            class="lang-specific-header-text lang-specific-split_text lang-specific-font-name"
            [ngStyle]="{
              'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
            }"
            [ngClass]="[
              isMac + 'header-text',
              isMac + 'lang-specific-split_text'
            ]"
            >{{ 'LANG00159' | translate }}{{ ' ' }}{{ data.info.splits }}</span
          >

          <img
            class="icons soft17_icon"
            [ngClass]="[isMac + 'soft17_icon']"
            src="./assets/images/lobby_sprite_images/common/lobby_icons/soft17_icon.webp"
          />
          <span
            class="lang-specific-header-text lang-specific-soft17_text lang-specific-font-name"
            [ngStyle]="{
              'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
            }"
            [ngClass]="[isMac + 'header-text']"
            >{{ 'LANG00155' | translate }}</span
          >

          <div
            class="naturals-container"
            [ngClass]="[isMac + 'naturals-container']"
          >
            <div class="pays">
              <img
                class="pay-img"
                *ngFor="let naturals of rptInfo.naturals"
                src="./assets/images/lobby_sprite_images/lang_sprite_images/{{
                  data.currentLanguage
                }}_fcg/{{ data.currentLanguage }}_pays_{{ naturals }}.webp"
              />
            </div>
          </div>

          <div
            class="insurance-container"
            [ngClass]="[isMac + 'insurance-container']"
          >
            <div class="pays">
              <img
                class="pay-img"
                *ngFor="let insurance of rptInfo.insurance"
                src="./assets/images/lobby_sprite_images/lang_sprite_images/{{
                  data.currentLanguage
                }}_fcg/{{ data.currentLanguage }}_pays_{{ insurance }}.webp"
              />
            </div>
          </div>

          <div
            class="roulette-container"
            [ngClass]="[isMac + 'roulette-container']"
          >
            <div class="pays">
              <img
                class="pay-img"
                *ngFor="let roulette of rptInfo.roulette"
                src="./assets/images/lobby_sprite_images/lang_sprite_images/{{
                  data.currentLanguage
                }}_fcg/{{ data.currentLanguage }}_pays_{{ roulette }}.webp"
              />
            </div>
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
